import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const notify = () => toast("Submitted");

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://formsubmit.co/6fcee071aec4b9218bc2b1ee4c1b0629";
    Object.keys(formData).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formData[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    notify();
  };

  return (
    <>
      <div>
        <form className="flex flex-col" onSubmit={handleSubmit}>
          <div className="sm:grid sm:grid-cols-2 gap-5">
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="input input-bordered w-full focus:border-purple-700 font-poppins custom-card text-gray-300"
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="E-Mail"
              className="input input-bordered w-full focus:border-purple-700 font-poppins custom-card mt-5 sm:mt-0 text-gray-300"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <textarea
            name="message"
            placeholder="Message"
            className="textarea textarea-bordered textarea-lg w-full mt-5 focus:border-purple-700 font-poppins custom-card text-gray-300"
            value={formData.message}
            onChange={handleChange}
          />
          <button
            type="submit"
            className="btn btn-ghost mx-auto mt-5 w-full glass-morphism text-white text-lg font-[poppins]"
          >
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default ContactForm;
